"use strict";function checkBizCall$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.checkBizCall$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.telephone.checkBizCall";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.0.0"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.5.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.5.6"},_a)),exports.checkBizCall$=checkBizCall$,exports.default=checkBizCall$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/telephone/checkBizCall.js
// module id = 995
// module chunks = 106